import React, { useContext, useState } from "react";
import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Spinner,
} from "react-bootstrap";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useNavigate } from "react-router";
import { Context } from "../../Shared/Context/GlobalContext";
import { useAuth } from "../../Shared/Hooks/useAuth";
import { useInputValue } from "../../Shared/Hooks/useInputValue";
import { CreateCustomerFormComponent } from "../CheckoutPage/components/CreateCustomerFormComponent";
import { Trans, useTranslation } from "react-i18next";
import routes from "../../Helpers/Routes.json";

function LoginPage({ doNavigate = true }) {
  const navigate = useNavigate();
  const username = useInputValue("", "username");
  const password = useInputValue("", "password");
  const [register, isRegister] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const auth = useAuth();
  const { setUser, user, domain } = useContext(Context);
  const { t } = useTranslation();

  const lostPasswordUrl = domain?.shop?.lost_password_url || "#";

  function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    auth
      .login(username.value, password.value)
      .catch(() => {
        setLoading(false);
      })
      .then(({ data, code }) => {
        setLoading(false);
        if (200 === code) {
          setError(null);
          setUser(data);
          if (doNavigate) {
            navigate("/");
          }
        } else {
          setError(true);
        }
      });
  }

  if (user) {
    return navigate(routes.AccountPage.index);
  }

  if (register) {
    return (
      <Container className="py-4" style={{ maxWidth: "500px" }}>
        <CreateCustomerFormComponent isRegister={isRegister} />
      </Container>
    );
  }

  return (
    <Container className="py-5" style={{ maxWidth: "440px" }}>
      <div className="card p-4 shadow-sm">
        <h1 className="h3 fw-bold mb-4 text-center">
          {t("Iniciar sesión")}
        </h1>

        {error && (
          <Alert variant="danger" className="small">
            {t("Usuario o contraseña incorrectos.")}
          </Alert>
        )}

        <Form method="POST" onSubmit={handleLogin}>
          <Form.Group className="mb-3">
            <Form.Label>{t("Email")}</Form.Label>
            <Form.Control
              {...username}
              isInvalid={error}
              placeholder="tu@email.com"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t("Contraseña")}</Form.Label>
            <InputGroup>
              <Form.Control
                required
                isInvalid={error}
                {...password}
                type={showPassword ? "text" : "password"}
              />
              <InputGroup.Text
                role="button"
                onClick={() => setShowPassword(!showPassword)}
                className="bg-white"
              >
                {showPassword ? (
                  <AiOutlineEyeInvisible />
                ) : (
                  <AiOutlineEye />
                )}
              </InputGroup.Text>
            </InputGroup>
          </Form.Group>

          <Button
            variant="dark"
            type="submit"
            className="w-100 rounded-pill d-flex align-items-center justify-content-center gap-2"
            disabled={loading}
          >
            {loading && <Spinner animation="border" size="sm" />}
            {t("Iniciar sesion")}
          </Button>
        </Form>

        <div className="text-center mt-3">
          <a
            href={lostPasswordUrl}
            target="_blank"
            rel="noreferrer"
            className="small"
          >
            {t("¿Has olvidado la contraseña?")}
          </a>
        </div>

        <hr />

        <div className="text-center small">
          <Trans
            i18nKey={
              "<Small>¿No tienes cuenta? <LoginLink>Registrate aquí</LoginLink></Small>"
            }
            components={{
              Small: <span />,
              LoginLink: (
                <span
                  role="button"
                  className="fw-bold"
                  style={{ color: "var(--tws-brown)", cursor: "pointer" }}
                  onClick={() => isRegister(true)}
                />
              ),
            }}
          />
        </div>
      </div>
    </Container>
  );
}

export default LoginPage;
